var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeco7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 394,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-767 -1588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M769.5 1785C769.5 1677.58 856.805 1590.5 964.5 1590.5 1072.2 1590.5 1159.5 1677.58 1159.5 1785 1159.5 1892.42 1072.2 1979.5 964.5 1979.5 856.805 1979.5 769.5 1892.42 769.5 1785Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#F80203",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco7);
export default __webpack_public_path__ + "static/media/deco7.d5b3e3a32e012a1b4bf51c9e67927c97.svg";
export { ForwardRef as ReactComponent };